var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthereumLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "96px",
    viewBox: "-18.532 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9ca3af",
    points: "127.9611 0 125.1661 9.5 125.1661 285.168 127.9611 287.958 255.9231 212.32",
    d: "M29.459 0L28.815 2.187L28.815 65.65L29.459 66.292L58.918 48.879Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ca3af",
    points: "127.962 0 0 212.32 127.962 287.959 127.962 154.158",
    d: "M29.459 0L0 48.879L29.459 66.293L29.459 35.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ca3af",
    points: "127.9611 312.1866 126.3861 314.1066 126.3861 412.3056 127.9611 416.9066 255.9991 236.5866",
    d: "M29.459 71.87L29.096 72.312L29.096 94.919L29.459 95.978L58.935 54.466Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ca3af",
    points: "127.962 416.9052 127.962 312.1852 0 236.5852",
    d: "M29.459 95.978L29.459 71.87L0 54.466Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ca3af",
    points: "127.9611 287.9577 255.9211 212.3207 127.9611 154.1587",
    d: "M29.459 66.292L58.917 48.88L29.459 35.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ca3af",
    points: "0.0009 212.3208 127.9609 287.9578 127.9609 154.1588",
    d: "M0 48.88L29.459 66.292L29.459 35.49Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumLogo);
export default __webpack_public_path__ + "static/media/ethereum-logo.563c377e6257821ef12114df9ab7173c.svg";
export { ForwardRef as ReactComponent };